import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { styled } from "@mui/material/styles";
import DashboardSidebar from "./Sidebar";
import DashboardNavbar from "./Navbar";
import { Backdrop, CircularProgress } from "@mui/material";

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 65;

export const RootStyle = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
});

export const MainStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);

  const [hover, sethover] = useState(false);

  const loading = false//useAppSelector((state) => state?.user?.loading);

  return (
    <RootStyle>
      <Backdrop
        sx={{
          zIndex: 1100,
        }}
        open={loading}
      >
        <div>
          {/* <img src={image} draggable="false" width={"50px"} /> */}
          <CircularProgress color="inherit" />
        </div>
      </Backdrop>

      <DashboardNavbar
        isOpenSidebar={open}
        onOpenSidebar={() => setOpen(true)}
      />
      <DashboardSidebar
        hover={hover}
        sethover={sethover}
        isOpenSidebar={open}
        onCloseSidebar={(value: boolean) => setOpen(value)}
      />
      <MainStyle>
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
